// extracted by mini-css-extract-plugin
module.exports = {"displayMode":"TooltipConfig_displayMode__3MO0G","title":"TooltipConfig_title__3-tUn"};